
export const getLocateDate = (value: string) => {
  return new Date(value).toLocaleDateString();
}

export const getLocateTime = (value: string) => {
  return new Date(value).toLocaleTimeString();
}